import { SetupDrawer } from '@Components/shared/dialogs/SetupDrawer';
import { SetupUserDrawerContent } from './SetupUserDrawerContent';
import { useUserDrawer } from '@Modal/hooks/users/useUserDrawer';

export const SetupUserDrawer: React.FC = () => {
  const { showUserDrawer, handleCreateCancel } = useUserDrawer();

  return (
    <SetupDrawer
      name="SetupRound"
      open={showUserDrawer}
      onClose={handleCreateCancel}
    >
      <SetupUserDrawerContent />
    </SetupDrawer>
  );
};
